import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SkipQuestionModalState {
  alwaysShowSkipModal: boolean;
  hideSkipModalForNow: () => void;
  hideSkipModalForever: () => void;
  setAlwaysShowSkipModal: (value: boolean) => void;
  setShowSkipModal: (value: boolean) => void;
  setSkipQuestion: (value: boolean) => void;
  showSkipModal: boolean;
  skipQuestion: boolean;
}

export const useSkipQuestionStore = create<SkipQuestionModalState>()(
  persist(
    (set) => ({
      skipQuestion: false,
      setSkipQuestion: (skipQuestion: boolean) => set(() => ({ skipQuestion })),

      showSkipModal: false,
      setShowSkipModal: (showSkipModal: boolean) => set(() => ({ showSkipModal })),

      alwaysShowSkipModal: true,
      setAlwaysShowSkipModal: (alwaysShowSkipModal: boolean) =>
        set(() => ({ alwaysShowSkipModal })),

      hideSkipModalForNow: () => set(() => ({ alwaysShowSkipModal: true, showSkipModal: false })),
      hideSkipModalForever: () => set(() => ({ alwaysShowSkipModal: false, showSkipModal: false })),
    }),

    {
      name: 'skip-question',
    },
  ),
);
